module.exports = __webpack_public_path__ + "img/map-marker-red.f2fbacd3.png";